
import errorResponseMessage from "./getErrorMessage";
import { AxiosRequestConfig } from 'axios';
async function caller(methodFunc, endpoint: string, model?: any , body?: any, axiosConfig?: AxiosRequestConfig) {
  const response = body? 
  await methodFunc(encodeURI(endpoint), body, axiosConfig) : 
  await methodFunc(encodeURI(endpoint), undefined, axiosConfig)

  if (response.ok) {
    return model? model(response) : response
  } else {
    const errorMsg = errorResponseMessage(response);
    try {
      // log full response to help debugging 500 errors from backend
      // this helps inspect status and response body in dev console
      console.error("API error:", { endpoint, status: response.status, data: response.data, message: errorMsg });
    } catch (e) {
      // ignore logging errors
    }
    return Object.assign(new Error("error"), {
      message: "error from api",
      ...response,
      errorType: endpoint,
    });
  }
}

export default caller;
